import CalendarBody from './components/CalendarBody';
import useCalendar from './hooks/useCalendar';

export default {
    useCalendar,
    Body: CalendarBody,
};